import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConcurrentRequestHandlingService } from '@modules/common/services/concurrent-request-handling.service';
import { ApiProxyOptions } from '@modules/common/models/api-proxy-options';
import { GetDynamicMenusResult } from './get-dynamic-menus-result.generated';

@Injectable({
    providedIn: 'root'
})
export class GetDynamicMenusService {
    constructor(private _concurrentRequestHandlingService: ConcurrentRequestHandlingService) { }

    public getDynamicMenus(options?: ApiProxyOptions): Observable<GetDynamicMenusResult> {
        return this._concurrentRequestHandlingService.callApi<GetDynamicMenusResult>(
            "GetDynamicMenusService_getDynamicMenus",
            {
                url: '/DynamicMenus/GetDynamicMenus/GetDynamicMenus',
                body: {},
                sendCredentials: true
            }, options
        );
    }
}
